/**
 * Capitalized the string, which means the letter is upper case and the rest of letters are lower case.
 *
 * @param str a string
 * @returns a capitalized string
 */
export const capitalizeStr = (str: string) => {
  if (str.length > 0) {
    return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
  }

  return str;
};
